var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0944 19.075C16.8228 21.3466 12.0054 23.3106 8.09563 20.8945C7.87804 20.76 7.76925 20.6928 7.68699 20.6602C7.52971 20.5979 7.41043 20.5799 7.24178 20.5929C7.15356 20.5997 7.05362 20.6257 6.85373 20.6775C5.59593 21.0035 4.96704 21.1665 4.51396 21.0743C3.72759 20.9142 3.11302 20.2997 2.95298 19.5133C2.86078 19.0602 3.02378 18.4313 3.34979 17.1735C3.40161 16.9736 3.42752 16.8736 3.43431 16.7851C3.44725 16.6165 3.42886 16.4958 3.36627 16.3386C3.33344 16.2562 3.2663 16.1482 3.13203 15.9321C0.707555 12.0308 2.58389 7.30123 4.95228 4.93284C8.85752 1.0276 15.1892 1.0276 19.0944 4.93284C22.9997 8.83808 22.9997 15.1697 19.0944 19.075Z",
    stroke: "#585858",
    strokeWidth: 1.63636
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18182 12.0909C9.18182 12.6934 8.6934 13.1818 8.09091 13.1818C7.48842 13.1818 7 12.6934 7 12.0909C7 11.4884 7.48842 11 8.09091 11C8.6934 11 9.18182 11.4884 9.18182 12.0909Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5455 12.0909C13.5455 12.6934 13.057 13.1818 12.4545 13.1818C11.8521 13.1818 11.3636 12.6934 11.3636 12.0909C11.3636 11.4884 11.8521 11 12.4545 11C13.057 11 13.5455 11.4884 13.5455 12.0909Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9091 12.0909C17.9091 12.6934 17.4207 13.1818 16.8182 13.1818C16.2157 13.1818 15.7273 12.6934 15.7273 12.0909C15.7273 11.4884 16.2157 11 16.8182 11C17.4207 11 17.9091 11.4884 17.9091 12.0909Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChat);
export default __webpack_public_path__ + "static/media/group-chat.8a93a896a8eb6065ab4216a73b5d0e20.svg";
export { ForwardRef as ReactComponent };